export interface VideoItem {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  authorName: string;
  authorAvatar: string;
  views: number;
  likes: number;
  duration: string;
  categorySlug: string;
  categoryName: string;
  tags: string[];
  publishDate: string;
  isHot: boolean;
}

export const allVideos: VideoItem[] = [
  {
    id: 'v001',
    title: '当猫咪学会开门后，铲屎官彻底崩溃了',
    description: '家里三只猫轮流表演开门绝技，铲屎官装了三把锁都挡不住，最后只能认命...全程高能笑到肚子疼！',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20orange%20tabby%20cat%20reaching%20up%20to%20open%20a%20door%20handle%20with%20its%20paw%2C%20bright%20indoor%20lighting%2C%20warm%20home%20interior%2C%20clean%20minimalist%20background%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20warm%20tones&width=800&height=450&seq=video-thumb-001&orientation=landscape',
    authorName: '猫咪观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20cat%20face%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20orange%20and%20cream%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-001&orientation=squarish',
    views: 2850000,
    likes: 356000,
    duration: '02:35',
    categorySlug: 'gaoxiao',
    categoryName: '搞笑',
    tags: ['猫咪', '萌宠', '搞笑日常', '铲屎官'],
    publishDate: '2026-08-08',
    isHot: true,
  },
  {
    id: 'v002',
    title: '深夜食堂：5分钟搞定米其林级别黯然销魂饭',
    description: '简单食材做出高级感，一碗饭让你忘记所有烦恼。附赠灵魂酱汁配方，学会了可以开店！',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautifully%20plated%20bowl%20of%20fried%20rice%20with%20runny%20egg%20on%20top%2C%20steaming%20hot%2C%20warm%20kitchen%20lighting%2C%20clean%20white%20ceramic%20bowl%2C%20minimalist%20food%20photography%2C%20soft%20shadows%2C%20warm%20amber%20tones&width=800&height=450&seq=video-thumb-002&orientation=landscape',
    authorName: '厨房小当家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chef%20hat%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20yellow%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-002&orientation=squarish',
    views: 1680000,
    likes: 245000,
    duration: '05:12',
    categorySlug: 'meishi',
    categoryName: '美食',
    tags: ['美食', '深夜食堂', '黯然销魂饭', '家常菜'],
    publishDate: '2026-08-07',
    isHot: true,
  },
  {
    id: 'v003',
    title: '街头钢琴师即兴演奏《起风了》，路人纷纷驻足落泪',
    description: '在东京街头，一位不知名的钢琴师用公共钢琴演奏了这首曲子，整条街都安静了...',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20playing%20a%20public%20piano%20on%20a%20city%20street%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20urban%20background%20slightly%20blurred%2C%20emotional%20atmosphere%2C%20cinematic%20photography%2C%20warm%20tones&width=800&height=450&seq=video-thumb-003&orientation=landscape',
    authorName: '街头音乐人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Music%20note%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20pink%20and%20cream%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-003&orientation=squarish',
    views: 4200000,
    likes: 598000,
    duration: '03:48',
    categorySlug: 'yinyue',
    categoryName: '音乐',
    tags: ['音乐', '街头钢琴', '起风了', '感动'],
    publishDate: '2026-08-06',
    isHot: true,
  },
  {
    id: 'v004',
    title: '《黑神话：悟空》隐藏BOSS无伤速通攻略，太震撼了',
    description: '全网最快无伤通关！详细讲解每一个机制和应对策略，手残党也能学会的高端操作。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20monkey%20king%20character%20in%20a%20dark%20mythical%20game%20scene%20with%20dramatic%20lighting%2C%20ancient%20Chinese%20aesthetic%2C%20cinematic%20game%20screenshot%20style%2C%20warm%20golden%20and%20dark%20tones&width=800&height=450&seq=video-thumb-004&orientation=landscape',
    authorName: '游戏达人老A',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Game%20controller%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20green%20and%20dark%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-004&orientation=squarish',
    views: 5600000,
    likes: 789000,
    duration: '12:45',
    categorySlug: 'youxi',
    categoryName: '游戏',
    tags: ['游戏', '黑神话悟空', '攻略', '无伤速通'],
    publishDate: '2026-08-05',
    isHot: true,
  },
  {
    id: 'v005',
    title: '冰岛环岛自驾攻略：10天花费不到2万，美到窒息',
    description: '极光、冰川、温泉、黑沙滩...一次性看完冰岛所有精华景点，附详细路线和预算清单。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20Iceland%20landscape%20with%20northern%20lights%20over%20snowy%20mountains%2C%20dramatic%20sky%2C%20minimalist%20composition%2C%20travel%20photography%2C%20cool%20teal%20and%20warm%20green%20tones&width=800&height=450&seq=video-thumb-005&orientation=landscape',
    authorName: '旅行日记本',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Earth%20globe%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20teal%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-005&orientation=squarish',
    views: 1920000,
    likes: 278000,
    duration: '08:20',
    categorySlug: 'lvxing',
    categoryName: '旅行',
    tags: ['旅行', '冰岛', '自驾', '极光'],
    publishDate: '2026-08-04',
    isHot: true,
  },
  {
    id: 'v006',
    title: '苹果Vision Pro上手30天真实体验：值不值得买？',
    description: '从日常使用到工作效率，全方位实测这款三万块的头显到底能不能替代你的电脑和手机。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20VR%20headset%20on%20a%20clean%20white%20desk%20with%20soft%20natural%20lighting%2C%20minimalist%20tech%20product%20photography%2C%20sleek%20modern%20design%2C%20warm%20silver%20and%20white%20tones&width=800&height=450&seq=video-thumb-006&orientation=landscape',
    authorName: '数码测评室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Circuit%20board%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20gray%20and%20teal%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-006&orientation=squarish',
    views: 3100000,
    likes: 423000,
    duration: '15:30',
    categorySlug: 'keji',
    categoryName: '科技',
    tags: ['科技', '苹果', 'Vision Pro', '评测'],
    publishDate: '2026-08-03',
    isHot: true,
  },
  {
    id: 'v007',
    title: '搞笑一家人：老爸学用智能手机，把全家整崩溃了',
    description: '教老爸用手机的过程中发生的各种爆笑瞬间，语音输入永远识别不对，最后他还把Siri骂哭了...',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20confused%20elderly%20man%20holding%20a%20smartphone%20with%20a%20funny%20expression%2C%20bright%20living%20room%20setting%2C%20warm%20humorous%20family%20scene%2C%20natural%20lighting%2C%20clean%20composition&width=800&height=450&seq=video-thumb-007&orientation=landscape',
    authorName: '欢乐一家人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Smiling%20family%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20orange%20and%20yellow%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-007&orientation=squarish',
    views: 1980000,
    likes: 267000,
    duration: '03:15',
    categorySlug: 'gaoxiao',
    categoryName: '搞笑',
    tags: ['搞笑', '家庭', '智能手机', '老爸'],
    publishDate: '2026-08-02',
    isHot: false,
  },
  {
    id: 'v008',
    title: 'NBA季后赛十大绝杀时刻：每一球都让人头皮发麻',
    description: '从乔丹到库里，盘点NBA历史上最令人窒息的绝杀进球，看到最后一个我哭了...',
    thumbnail: 'https://readdy.ai/api/search-image?query=Basketball%20player%20making%20a%20game%20winning%20shot%20in%20a%20packed%20arena%2C%20dramatic%20sports%20photography%2C%20intense%20atmosphere%2C%20warm%20stadium%20lighting%2C%20action%20shot&width=800&height=450&seq=video-thumb-008&orientation=landscape',
    authorName: '篮球狂热者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Basketball%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20red%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-008&orientation=squarish',
    views: 2450000,
    likes: 389000,
    duration: '10:55',
    categorySlug: 'tiyu',
    categoryName: '体育',
    tags: ['体育', 'NBA', '绝杀', '篮球'],
    publishDate: '2026-08-01',
    isHot: false,
  },
  {
    id: 'v009',
    title: '2026夏季穿搭指南：5套百搭look让你回头率翻倍',
    description: '从通勤到约会全覆盖，平价也能穿出高级感。附链接，每一件都是我亲自试过的！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stylish%20summer%20outfit%20flat%20lay%20on%20a%20clean%20white%20background%2C%20minimalist%20fashion%20photography%2C%20neutral%20earth%20tones%2C%20soft%20natural%20light%2C%20elegant%20composition&width=800&height=450&seq=video-thumb-009&orientation=landscape',
    authorName: '穿搭小能手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fashion%20hanger%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20pink%20and%20cream%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-009&orientation=squarish',
    views: 1350000,
    likes: 198000,
    duration: '06:40',
    categorySlug: 'shishang',
    categoryName: '时尚',
    tags: ['时尚', '穿搭', '夏季', '百搭'],
    publishDate: '2026-07-31',
    isHot: false,
  },
  {
    id: 'v010',
    title: '一个人吃火锅是什么体验？老板送了我一整盘毛肚',
    description: '鼓起勇气一个人去吃火锅，没想到老板看我一个人太可怜，直接送了我一盘毛肚还陪我聊天...',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20single%20person%20sitting%20at%20a%20table%20with%20a%20steaming%20hotpot%2C%20warm%20restaurant%20lighting%2C%20cozy%20atmosphere%2C%20Chinese%20hotpot%20restaurant%20interior%2C%20minimalist%20food%20photography&width=800&height=450&seq=video-thumb-010&orientation=landscape',
    authorName: '孤独美食家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chopsticks%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20red%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-010&orientation=squarish',
    views: 980000,
    likes: 156000,
    duration: '04:25',
    categorySlug: 'meishi',
    categoryName: '美食',
    tags: ['美食', '火锅', '一个人', '暖心'],
    publishDate: '2026-07-30',
    isHot: false,
  },
  {
    id: 'v011',
    title: '吉他指弹《晴天》教学，手把手教会你每一个音符',
    description: '适合初学者的详细指弹教学，每个小节都拆解到最细，跟着练保证一周学会！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20playing%20acoustic%20guitar%20strings%2C%20warm%20wooden%20texture%2C%20soft%20natural%20light%2C%20cozy%20room%20background%2C%20minimalist%20music%20photography%2C%20warm%20amber%20tones&width=800&height=450&seq=video-thumb-011&orientation=landscape',
    authorName: '吉他教室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Guitar%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20warm%20brown%20and%20cream%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-011&orientation=squarish',
    views: 875000,
    likes: 134000,
    duration: '18:20',
    categorySlug: 'yinyue',
    categoryName: '音乐',
    tags: ['音乐', '吉他', '教学', '晴天'],
    publishDate: '2026-07-29',
    isHot: false,
  },
  {
    id: 'v012',
    title: '《原神》5.0版本全角色强度排行，T0只有这三位',
    description: '深度分析5.0版本所有角色的实战表现，附深渊满星配队推荐，抽卡前必看！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20game%20characters%20in%20a%20vibrant%20magical%20landscape%2C%20colorful%20and%20dynamic%20composition%2C%20soft%20glowing%20effects%2C%20warm%20golden%20and%20green%20tones&width=800&height=450&seq=video-thumb-012&orientation=landscape',
    authorName: '二次元研究员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anime%20star%20cartoon%20avatar%20icon%2C%20simple%20flat%20design%2C%20pink%20and%20white%20colors%2C%20minimalist%20style%2C%20illustration&width=100&height=100&seq=avatar-012&orientation=squarish',
    views: 3400000,
    likes: 467000,
    duration: '09:15',
    categorySlug: 'youxi',
    categoryName: '游戏',
    tags: ['游戏', '原神', '角色排行', '攻略'],
    publishDate: '2026-07-28',
    isHot: false,
  },
];

export const getVideosByCategory = (categorySlug: string) =>
  allVideos.filter((v) => v.categorySlug === categorySlug);

export const getVideoById = (id: string) =>
  allVideos.find((v) => v.id === id);

export const getHotVideos = (limit: number = 6) =>
  allVideos.filter((v) => v.isHot).slice(0, limit);

export const getRelatedVideos = (videoId: string, limit: number = 4) =>
  allVideos.filter((v) => v.id !== videoId).slice(0, limit);